import {
  Calculator,
  Receipt,
  Building2,
  Banknote,
  TrendingUp,
  BadgeCheck,
  Landmark,
  Building,
  Users,
} from "lucide-react";
import PageHero from "../../components/shared/PageHero";
import CtaBand from "../../components/shared/CtaBand";
import "./BusinessServicesPage.css";

const SERVICES = [
  {
    id: "accounting",
    icon: Calculator,
    title: "Accounting & Auditing",
    desc: "Books, MIS, statutory audits, and clean financials for startups and established firms — so lenders and investors trust your numbers.",
  },
  {
    id: "tax",
    icon: Receipt,
    title: "Tax Planning",
    desc: "Smart structures across income, investments, and business operations — compliance-first planning that reduces leakage legally.",
  },
  {
    id: "formation",
    icon: Building2,
    title: "Company Registration",
    desc: "End-to-end Private Limited, LLP, and related registrations with documentation, DSC/DIN, and post-incorporation compliance.",
  },
  {
    id: "debt",
    icon: Banknote,
    title: "Debt Funding",
    desc: "Business loans and structured debt via banking and NBFC channels — preparation, packaging, and follow-through to disbursement.",
  },
  {
    id: "equity",
    icon: TrendingUp,
    title: "Equity Funding",
    desc: "Pitch readiness, financial modelling support, and investor connects for founders raising growth capital.",
  },
  {
    id: "schemes",
    icon: BadgeCheck,
    title: "Government Schemes",
    desc: "Identify MSME incentives, subsidies, and eligible programmes — then navigate applications with documentation support.",
  },
  {
    id: "loans",
    icon: Landmark,
    title: "Business Loans",
    desc: "Working capital, term loans, and equipment finance guidance matched to cash flows and repayment capacity.",
  },
  {
    id: "nbfc",
    icon: Building,
    title: "NBFC",
    desc: "NBFC structuring advice, product design support, and regulatory-aware pathways for financial services businesses.",
  },
  {
    id: "cooperative",
    icon: Users,
    title: "Cooperative Banking",
    desc: "Advisory for cooperative banking products and community-focused finance structures suited to local ecosystems.",
  },
];

export default function BusinessServicesPage() {
  return (
    <div className="biz-page">
      <PageHero
        badge="Business Services"
        title="Finance & compliance for growing enterprises"
        subtitle="Accounting, tax, company formation, debt & equity funding, government schemes, NBFC and cooperative banking — under one roof."
        actions={[
          { label: "Book Free Consultation", to: "/contact", primary: true },
          { label: "All Services", to: "/services" },
        ]}
      />

      <section className="pm-section biz-section">
        <div className="pm-container">
          <span className="pm-badge">
            <span className="pm-badge-dot" />
            For Founders & SMEs
          </span>
          <h2 className="pm-section-title">Business solutions</h2>
          <p className="pm-section-sub">
            From incorporation to funding — practical support for Indian
            businesses.
          </p>

          <div className="biz-grid">
            {SERVICES.map((s) => {
              const Icon = s.icon;
              return (
                <article key={s.id} id={s.id} className="pm-card biz-card">
                  <div className="biz-card__icon">
                    <Icon size={22} />
                  </div>
                  <h3>{s.title}</h3>
                  <p>{s.desc}</p>
                </article>
              );
            })}
          </div>
        </div>
      </section>

      <CtaBand
        title="Building or funding your business?"
        subtitle="Talk to our CA/CS-led team about accounting, tax, formation, or capital raise support."
        primary={{ label: "Book Free Consultation", to: "/contact" }}
        secondary={{ label: "Talk to an Expert", to: "/contact" }}
      />
    </div>
  );
}
